export let RouteUrls = {
  Settings: 'Settings',
  NoAccess: 'NoAccess',
  GeneralSettings: "/Settings/GeneralSettings",
  Common: {
    Delete: 'javascript:openDeleteConfirmation()',
    Archive: 'javascript:openDeleteConfirmation()',
    Print: 'javascript:sendPrintMsg()',
    Export: 'javascript:sendExcelMsg()',
  },
  ApplicationTemplates: {
    List: '/Settings/ApplicationTemplates/List',
    Update: '/Settings/ApplicationTemplates/Update',
    UpdateSection: '/Settings/ApplicationTemplates/UpdateSaction',
    DirectApplyApplicationForm: '/Settings/DirectApply/Create',
    Archived: 'Settings/ApplicationTemplates/Archived'
  },
  CustomFields: {
    List: 'Settings/CustomFields/List',
    CreateGet: 'Settings/CustomFields/Create'
  },
  SecurityRoles: {
    List: 'Settings/SecurityRoles/List',
    Create: 'Settings/SecurityRoles/Create'
  },
  AddressBooks: {
    List: '/Settings/GeneralSettings/AddressBooks/List',
    Create: '/Settings/GeneralSettings/AddressBooks/Create'
  },
  AdvertCategories: {
    List: '/Settings/GeneralSettings/AdvertCategories/List',
    Create: '/Settings/GeneralSettings/AdvertCategories/Create'
  },
  Adverts: {
    List: '/Settings/GeneralSettings/Adverts/List',
    Create: '/Settings/GeneralSettings/Adverts/Create'
  },
  Agencies: {
    List: '/Settings/GeneralSettings/Agencies/List',
    Create: '/Settings/GeneralSettings/Agencies/Create'
  },
  Campaigns: {
    List: '/Settings/GeneralSettings/Campaigns/List',
    Create: '/Settings/GeneralSettings/Campaigns/Create'
  },
  ApplicationStatuses: {
    List: '/Settings/GeneralSettings/ApplicationStatuses/List',
    DragDrop: '/Settings/GeneralSettings/ApplicationStatuses/Drag-Drop-List',
    Create: '/Settings/GeneralSettings/ApplicationStatuses/Create'
  },
  Departments: {
    List: '/Settings/GeneralSettings/Departments/List',
    Create: '/Settings/GeneralSettings/Departments/Create'
  },
  Divisions: {
    List: '/Settings/GeneralSettings/Divisions/List',
    Create: '/Settings/GeneralSettings/Divisions/Create'
  },
  FundingSource: {
    List: '/Settings/GeneralSettings/FundingSource/List',
    Create: '/Settings/GeneralSettings/FundingSource/Create'
  },
  EthnicOrigins: {
    List: '/Settings/GeneralSettings/EthnicOrigins/List',
    Create: '/Settings/GeneralSettings/EthnicOrigins/Create'
  },

  JobCategories: {
    List: '/Settings/GeneralSettings/JobCategories/List',
    Create: '/Settings/GeneralSettings/JobCategories/Create'
  },
  JobLevels: {
    List: '/Settings/GeneralSettings/JobLevels/List',
    Create: '/Settings/GeneralSettings/JobLevels/Create'
  },
  JobCodes: {
    List: '/Settings/GeneralSettings/JobCodes/List',
    Create: '/Settings/GeneralSettings/JobCodes/Create'
  },
  StatusChangeReasons: {
    List: '/Settings/GeneralSettings/StatusChangeReasons/List',
    Create: '/Settings/GeneralSettings/StatusChangeReasons/Create'
  },
  Skills: {
    List: '/Settings/GeneralSettings/Skills/List',
    Create: '/Settings/GeneralSettings/Skills/Create'
  },
  Nylas: {
    List: "/Settings/GeneralSettings/IndividualAccount/List",
    Create: "/Settings/GeneralSettings/IndividualAccount/Create",
    Inbox: "/Settings/Emails/Inbox",
    PersonalInbox: "/Settings/Emails/PersonalInbox",
  },
  SkillCategories: {
    List: '/Settings/GeneralSettings/SkillCategories/List',
    Create: '/Settings/GeneralSettings/SkillCategories/Create'
  },
  JobRegions: {
    List: '/Settings/GeneralSettings/JobRegions/List',
    Create: '/Settings/GeneralSettings/JobRegions/Create'
  },
  JobTitles: {
    List: '/Settings/GeneralSettings/JobTitles/List',
    Create: '/Settings/GeneralSettings/JobTitles/Create'
  },
  Locations: {
    List: '/Settings/GeneralSettings/Locations/List',
    Create: '/Settings/GeneralSettings/Locations/Create'
  },
  SalaryBands: {
    List: '/Settings/GeneralSettings/SalaryBands/List',
    Create: '/Settings/GeneralSettings/SalaryBands/Create'
  },
  SalaryBandYears: {
    List: '/Settings/GeneralSettings/SalaryBands/Years/List',
    Create: '/Settings/GeneralSettings/SalaryBands/Years/Create'
  },
  SchoolLocations: {
    List: '/Settings/GeneralSettings/SchoolLocations/List',
    Create: '/Settings/GeneralSettings/SchoolLocations/Create'
  },
  SchoolSubjects: {
    List: '/Settings/GeneralSettings/SchoolSubjects/List',
    Create: '/Settings/GeneralSettings/SchoolSubjects/Create'
  },
  Communications: '/Communications',
  EmailOptions: {
    Index: '/Communications',
    List: '/Communications/EmailOptions/List',
    Create: '/Communications/EmailOptions/Create',
  },
  LetterOptions: {
    Index: '/Communications',
    List: '/Communications/LetterOptions/List',
    Create: '/Communications/LetterOptions/Create'
  },
  EmailInbox: {
    Details: '/Communications/EmailInbox/Details',
    List: '/Communications/EmailInbox/List',
    Forward: '/Communications/EmailInbox/Forward',
    Reply: '/Communications/EmailInbox/Reply',
    MarkAsRead: 'javascript:sendMessage(\'MarkAsRead\')',
    MarkAsUnRead: 'javascript:sendMessage(\'MarkAsUnRead\')'
  },
  EmailOutbox: {
    List: '/Communications/EmailOutbox/List',
    Details: '/Communications/EmailOutbox/Details',
    Forward: '/Communications/EmailOutbox/Forward',
    Print: '/Communications/EmailOutbox/Print',
  },
  SmsOptions: {
    Index: '/Communications',
    List: '/Communications/SmsOptions/List',
    Create: '/Communications/SmsOptions/Create',
  },
  SmsInbox: {
    Index: '/Communications',
    List: '/Communications/SmsInbox/List',
    Detail: '/Communications/SmsInbox/Detail',

  },
  SmsOutbox: {
    Index: '/Communications',
    List: '/Communications/SmsOutbox/List',
    Detail: '/Communications/SmsOutbox/Detail',
  },
  Contracts: {
    Index: '/Communications',
    List: '/Communications/Contracts/List',
    Create: '/Communications/Contracts/Create',
    ContractImageCreate: '/Communications/ContractSection/Image/Create',
    ContractImageList: '/Communications/ContractSection/Image/List'
  },
  ContractSection: {
    Index: '/Communications',
    List: '/Communications/ContractSection/List',
    Create: '/Communications/ContractSection/Create',
  },
  WorkLevels: {
    List: '/Settings/GeneralSettings/WorkLevels/List',
    Create: '/Settings/GeneralSettings/WorkLevels/Create'
  },
  GBPins: {
    List: '/Settings/GeneralSettings/GBPins/List',
    Create: '/Settings/GeneralSettings/GBPins/Create'
  },


  DocumentLibrary: {
    List: '/Settings/GeneralSettings/DocumentLibraries/List',
    Create: '/Settings/GeneralSettings/DocumentLibraries/Create',
    CopyUrl: '/Settings/GeneralSettings/DocumentLibraries/CopyUrl'

  },


  DocumentLibraries: {
    List: '/Settings/OnBoarding/DocumentLibraries/List',
    Create: '/Settings/OnBoarding/DocumentLibraries/Create',

  },

  OnBoardingSetting: {
    List: '/Settings/onboarding/DocumentLibraries/List',
    Create: '/Settings/GeneralSettings/DocumentLibraries/Create',
    Redirect: '/Settings/OnBoarding/'
  },


  LibraryTypes: {
    List: '/Settings/OnBoarding/LibraryTypes/List',
    Create: '/Settings/OnBoarding/LibraryTypes/Create'
  },
  ComplianceLibraryTypes: {
    List: 'Settings/ComplianceSettings/LibraryTypes/List',
    Create: 'Settings/ComplianceSettings/LibraryTypes/Create'
  },

  MediaText: {
    List: '/Settings/GreenRoom/MediaText/List',
    Create: '/Settings/GreenRoom/MediaText/Create'
  },

  MediaVideo: {
    List: '/Settings/GreenRoom/MediaVideo/List',
    Create: '/Settings/GreenRoom/MediaVideo/Create'
  },

  MediaImage: {
    ImagesList: '/Settings/MediaLibrary/ListImage',
    List: '/Settings/GreenRoom/MediaImage/List',
    Create: '/Settings/GreenRoom/MediaImage/Create',
    GenratedFrom: '',
    ClientName: '',
    DbName: '',

  },
  OnBoardingMediaText: {
    List: '/Settings/OnBoarding/MediaText/List',
    Create: '/Settings/OnBoarding/MediaText/Create'
  },

  OnBoardingMediaVideo: {
    List: '/Settings/OnBoarding/MediaVideo/List',
    Create: '/Settings/OnBoarding/MediaVideo/Create'
  },

  OnBoardingMediaImage: {
    List: '/Settings/OnBoarding/MediaImage/List',
    Create: '/Settings/OnBoarding/MediaImage/Create',
    GenratedFrom: '',
    ClientName: '',
    DbName: '',

  },
  OnboardingTemplates: {
    List: '/Settings/onboarding/DocumentLibraries/List',
    Create: '/Settings/GeneralSettings/DocumentLibraries/Create'
  },
  Packages: {
    List: '/Settings/GeneralSettings/Packages/List',
    Create: '/Settings/GeneralSettings/Packages/Create'
  },
  CostCentres: {
    List: '/Settings/GeneralSettings/CostCentres/List',
    Create: '/Settings/GeneralSettings/CostCentres/Create'
  },
  MyLocums: {
    MyLocums: '/WorkPlace/Locums/MyLocums',
    MyLocumslocations: '/WorkPlace/Locums/MyLocumslocations',
    MylocumsCandidates: '/WorkPlace/Locums/MylocumsCandidates'
  },

  GreenRoomTemplates: {
    List: '/Settings/GreenRoom/GreenRoomTemplates/List',
    Create: '/Settings/GreenRoom/GreenRoomTemplates/Create',

  },
  SmartSearch: {
    SmartSearch: '/Search/SmartSearch'
  },


  KeyContacts: {
    List: '/Settings/GreenRoom/KeyContacts/List',
    Create: '/Settings/GreenRoom/KeyContacts/Create'
  },
  Links: {
    List: '/Settings/GreenRoom/Links/List',
    Create: '/Settings/GreenRoom/Links/Create'
  },
  Managers: {
    List: '/Settings/GreenRoom/Managers/List',
    Create: '/Settings/GreenRoom/Managers/Create'
  },

  OnBoardingSettings: {
    Create: '/Settings/OnBoarding/OnBoardingSettings/Create'
  },
  AssessmentForms: {
    JTForms: {
      List: '/Settings/AssessmentForms/JTForms/List'
    },
    AssessmentForm: {
      List: 'Settings/AssessmentForms/AssessmentForm/List',
      Create: '/Settings/AssessmentForms/AssessmentForm/Create',
      Preview: '/Settings/AssessmentForms/AssessmentForm/Preview'
    },
    QuestionBank: {
      List: 'Settings/AssessmentForms/QuestionsBank/List',
      Create: '/Settings/AssessmentForms/QuestionsBank/Create',
      Preview: '/Settings/AssessmentForms/QuestionsBank/Preview'
    },
    TimedForms: {
      List: 'Settings/AssessmentForms/TimedForms/List',
      Create: '/Settings/AssessmentForms/TimedForms/Create'
    },
    JobType: {
      List: 'Settings/AssessmentForms/JobType/List',
      Create: '/Settings/AssessmentForms/JobType/Create'
    },
    ArchivedForms: {
      List: 'Settings/AssessmentForms/Archived/List'
    },
    ArchivedQuestions: {
      List: 'Settings/AssessmentForms/QuestionsBank/Archived'
    }
  },
  Search: {
    SearchResults: '/Search/SearchResults',
    NewSearh: '',
    JobAlerts: '/Search/JobAlerts',
    SaveCandidateAlerts: '/Search/SaveCandidateAlerts',
    ApplicationSearch: '/Search/ApplicationSearch',
    Candidate: '/Search/ListCandidates',
    OpportunityJobAlerts: '/Search/OpportunityJobAlerts',
    ListCandidate: 'Search/ListCandidates',
    Jobs: '/Search/Jobs',
    SearchCandidate: '/Search/Candidates',
    SearchKeywords: '/Search/Keyword',
    SavedSearch: '/Search/SavedSearch/List',
    DefferedCandidate: '/JobsAndTalents/Allocation/DeferredCandidates',
    TalentPoolProfile: '/JobsAndTalents/talent-profile/talent-pool-profile'
  },
  Teams: {
    List: '/Settings/Teams/List',
    Create: '/Settings/Teams/Create'
  },
  AuthorisationSetup: {
    List: '/Settings/AuthorisationSetup',
    SwapApprover: '/Settings/AuthorisationTemplates/SwapApprovers'
  },
  AuthorisationUsers: {
    List: '/Settings/AuthorisationUsers/List',
    Create: '/Settings/AuthorisationUsers/Create'
  },
  AuthorisationGroups: {
    List: '/Settings/AuthorisationGroups/List',
    Create: '/Settings/AuthorisationGroups/Create'
  },
  JobAuthorisationMasterTemplate: {
    Create: '/Settings/JobAuthorisationMasterTemplate/Create'
  },
  AuthorisationTemplates: {
    Create: '/Settings/AuthorisationTemplates/Create',
    List: '/Settings/AuthorisationTemplates/List',
    Edit: '/Settings/AuthorisationTemplates/Create',
    Copy: 'SystemSettings/CopyAuthorisationTemplate'
  },
  SystemPipelines: {
    Create: '/Settings/SystemPipeline/Create',
    List: '/Settings/SystemPipeline/List',
    Edit: '/Settings/SystemPipeline/Create',
  },
  MultiDocument: {
    List: '/Settings/MultipleDocumentsUploads/List',
    Create: '/Settings/MultipleDocumentsUploads/Create'
  },
  Candidate: {
    PersonalDetails: '/JobsAndTalents/ApplicationForm/PersonalDetails',
    CandidateDetails: '/JobsAndTalents/ApplicationForm/Candidates/Register',
    EqualOpps: '/JobsAndTalents/ApplicationForm/EqualOpps',
    AddEmployment: '/JobsAndTalents/ApplicationForm/AddEmployment',
    EmploymentDetails: '/JobsAndTalents/ApplicationForm/EmploymentDetails',
    ReferencesDetails: '/JobsAndTalents/ApplicationForm/ReferencesDetails',
    AddReferences: '/JobsAndTalents/ApplicationForm/AddReferences',
    AdditionalInfo: '/JobsAndTalents/ApplicationForm/AdditionalInfo',
    ProfessionalDetails: '/JobsAndTalents/ApplicationForm/ProfessionalDetails',
    ProfessionalEducationDetails: '/JobsAndTalents/ApplicationForm/Education/ProfessionalEducationDetails',
    SchoolEducationDetails: '/JobsAndTalents/ApplicationForm/Education/SchoolEducationDetails',
    AddProfessionalDetails: '/JobsAndTalents/ApplicationForm/AddProfessionalDetails',
    AddEducation: '/JobsAndTalents/ApplicationForm/Education/AddEducation',
    SchoolDetails: '/JobsAndTalents/ApplicationForm/SchoolDetails',
    AddSchoolDetails: '/JobsAndTalents/ApplicationForm/AddSchoolDetails',
    AddOtherDetails: '/JobsAndTalents/ApplicationForm/AddOtherDetails',
    AddProfessionalEducation: '/JobsAndTalents/ApplicationForm/AddProfessionalEducation',
    ProfessionalEducationPreview: '/JobsAndTalents/ApplicationForm/ProfessionalEducationPreview',
    AddCRB: '/JobsAndTalents/ApplicationForm/AddCRB',
    AddCV: '/JobsAndTalents/ApplicationForm/AddCV',
    MultipleDocuments: '/JobsAndTalents/ApplicationForm/MultipleDocuments',
    TattooImages: '/JobsAndTalents/ApplicationForm/TattooImages',
    Declaration: '/JobsAndTalents/ApplicationForm/Declaration',
    AssessmentForm: '/JobsAndTalents/ApplicationForm/AssessmentForm',
    PreAssessmentForm: '/JobsAndTalents/ApplicationForm/PreAssessmentForm',
    AssessmentFormB: '/JobsAndTalents/ApplicationForm/AssessmentFormB',
    Print: '/JobsAndTalents/Candidate/Print',
    PrintLetter: '/JobsAndTalents/Candidate/PrintLetter',
    PrintReference: '/JobsAndTalents/Candidate/PrintReference',
    PrintContract: '/JobsAndTalents/Candidate/PrintContract',
    CompareCandidates: '/JobsAndTalents/Candidate/CompareCandidates',
    OfferAuthorizationStep1: '/JobsAndTalents/Candidate/OfferAuthorizationStep1',
    OfferAuthorizationStep2: '/JobsAndTalents/Candidate/OfferAuthorizationStep2',
    OBStep1: '/JobsAndTalents/Candidate/OBStep1',
    OBStep2: '/JobsAndTalents/Candidate/OBStep2',
    StartOnboardingProcessStep2: 'JobsAndTalents/Candidate/StartOnboardingProcessStep2',
    StartOnboardingProcessStep1: 'JobsAndTalents/Candidate/StartOnboardingProcessStep1',
    ReferencesStep1: '/JobsAndTalents/Candidate/ReferencesStep1',
    ReferencesStep2: '/JobsAndTalents/Candidate/ReferencesStep2',
    ReferencesStep3: '/JobsAndTalents/Candidate/ReferencesStep3',
    GetRemainingReferences: '/JobsAndTalents/Candidate/RemainingReferences',
    OBRefStep1: '/JobsAndTalents/Candidate/OBRefStep1',
    PreviewContract: '/JobsAndTalents/Candidate/PreviewContract',
    PreviewContract1: 'JobsAndTalents/Candidate/PreviewContract',
    EditContract: '/JobsAndTalents/Candidate/EditContract',
    CalendarInterview: '/JobsAndTalents/CandidateList/CandidateInterviewChoice',
    BookCalendarInterview: '/JobsAndTalents/CandidateList/BookCandidateInterview',
    CandidateInterviewDetail: '/JobsAndTalents/CandidateList/CandidateInterview',
    PreviewForm: '/JobsAndTalents/Candidate/PreviewForm',
    PreviewForm1: 'JobsAndTalents/Candidate/PreviewForm',
    ConfirmReceipt: '/JobsAndTalents/Candidate/ConfirmReceipt',
    InvalidInformation: '/JobsAndTalents/Candidate/OnboardingInvalidInformation',
    referenceForm: '/JobsAndTalents/Candidate/referenceForm',
    referenceForm1: 'JobsAndTalents/Candidate/referenceForm',
    printAllOnboardingRef: '/JobsAndTalents/Candidate/printAllOnboardingRef',
    ReferenceOB3: '/JobsAndTalents/Candidate/ReferenceOB',
    ResetComplianceItem: '/JobsAndTalents/Candidate/ResetComplianceItem',
    ComplianceConfirmReceipt: '/JobsAndTalents/Candidate/ComplianceConfirmReceipt',
    ComplianceInvalidInformation: '/JobsAndTalents/Candidate/ComplianceInvalidInformation',
    PreviewComplianceForm: '/JobsAndTalents/Candidate/previewComplianceForm',
    PreviewComplianceForm1: 'JobsAndTalents/Candidate/previewComplianceForm',
    printAllCompliance: '/JobsAndTalents/Candidate/printAllCompliance',
    CMPStep1: '/JobsAndTalents/Candidate/StartOnboardingProcess',
    SendRefreeEmail: 'JobsAndTalents/Candidate/Detail/Email',
    ResetOnboardingItem: '/JobsAndTalents/Candidate/ResetOnboardingItem',
    completereferenceForm: '/JobsAndTalents/Candidate/MarkCompleteReferenc',
    PrefrencesForm: '/JobsAndTalents/ApplicationForm/PrefrencesForm',
    ThankYou: '/JobsAndTalents/ApplicationForm/ThankYou',
    Documnets: '/JobsAndTalents/Documents/DownloadApplicationDocuments',
    PreviewComplianceContract: "/JobsAndTalents/Candidate/PreviewComplianceContract",
    NTUDocumentsExport: "/JobsAndTalents/NTUDoc/NTUDocumentsExport"



  },
  Talents: {
    List: '/JobsAndTalents/Jobs/Talents/List',
    Create: '/JobsAndTalents/Jobs/Talents/Create',
    LinkUrl: '/JobsAndTalents/Jobs/PoolCandidates/List',
    Edit: '/JobsAndTalents/Jobs/Talents/Create?id=',
    TalentPoolListist: '/JobsAndTalents/crm-talent-pool/talent-pool-list',
    TalentPoolDetail: 'TalentPool/TalentPoolDetail?talentPoolId='
  },
  Jobs: {
    List: '/JobsAndTalents/Jobs/List',
    LinkUrl: '/JobsAndTalents/CandidateList/List',
  },
  MyJobs: {
    List: '/WorkPlace/Myjobs',
  },


  TalentsCommunity: {
    List: '/JobsAndTalents/Capture/TalentCapture/List',
    Create: '/JobsAndTalents/Capture/TalentCapture/Create',
  },
  GradeFare: {
    TalentList: '/JobsAndTalents/Capture/TalentList',
    TalentProfile: '/JobsAndTalents/Capture/TalentProfile',
    SendEmail: '/JobsAndTalents/Capture/SendEmail',
    PrintLetter: '/JobsAndTalents/Capture/PrintLetter',
    EditCandidate: '/JobsAndTalents/Capture/EditCandidate',
    AddCandidate: 'Capture/AddCandidate',
    AssingToRecruiter: '/JobsAndTalents/Capture/AssingToRecruiter',
    List: '/JobsAndTalents/Capture/TalentCapture/List',
    Create: '/JobsAndTalents/Capture/TalentCapture/Create',
  },
  Templates: {
    List: '/Settings/OnBoarding/Templates/List',
    Create: '/Settings/OnBoarding/Templates/Create'
  },

  OnBoardingForm: {
    List: '/Settings/OnBoarding/OnboardingForm/List',
    Create: '/Settings/OnBoarding/OnboardingForm/Create',
    MatrixQuestion: '/Settings/OnBoarding/OnboardingForm/MatrixQuestion',
    Questions: '/Settings/OnBoarding/OnboardingForm/Questions',
    ComplianceFormList: '/Settings/OnBoarding/OnboardingForm/Compliance/List',
    ComplianceFormCreate: '/Settings/OnBoarding/OnboardingForm/Compliance/Create',

  },
  Calendar: {
    CalendarEntryDecide: '/Calendar/AddCalendarEntry/CalendarEntryDecide',
    List: '/Calendar/ListEvent',
    Create: '/Calendar/AddCalendarEntry/NewCalendarEntry',
    Job: '/Calendar/AddCalendarEntry/NewCalendarEntry/Job',
    DateTime: '/Calendar/AddCalendarEntry/NewCalendarEntry/DateTime',
    EmailSearch: '/Calendar/AddCalendarEntry/NewCalendarEntry/EmailSerach',
    Interviewer: '/Calendar/AddCalendarEntry/NewCalendarEntry/Interviewer',
    User: '/Calendar/AddCalendarEntry/NewCalendarEntry/User',
    Note: '/Calendar/AddCalendarEntry/NewCalendarEntry/Notes',
    Booked: '/Calendar/AddCalendarEntry/NewCalendarEntry/Booked',
    Vacant: '/Calendar/AddCalendarEntry/NewCalendarEntry/Vacant',
    ListAppointment: '/Calendar/Action/ListAppointments',
    ListSlots: 'Calendar/Action/ListSlots',
    AppointmentConfirm: 'Calendar/Action/AppointmentConfirm',
    AppointmentSave: 'Calendar/Action/AppointmentSave',
    ViewCalander: 'Calendar/Action/ViewCalender',
    Print: 'Calendar/AddCalendarEntry/Print'
  },
  Candidatelist: {
    Back: '/JobsAndTalents/Jobs/List',
    VideoInterview: 'javascript:inviteToInterview()',
    ShlScores: 'JobsAndTalents/CandidateList/ShlScores',
    PipeLine: '/JobsAndTalents/CandidateList/PipeLine',
    Tasks: '/JobsAndTalents/CandidateList/Tasks',
    Calendar: '/JobsAndTalents/CandidateList/Calendar',
    Reports: '/JobsAndTalents/CandidateList/Reports',
    PrintApplication: '/JobsAndTalents/CandidateList/PrintApplication',
    OfferEmail: '/JobsAndTalents/CandidateList/OfferEmail',
    MyJobs: '/WorkPlace/Myjobs'
  },
  SystemUser: {
    Create: '/Settings/UserSetting/Create',
    Update: '/Settings/UserSetting/Update',
    UpdatePassword: '/Settings/UserSetting/UpdatePassword',
    Detail: '/Settings/UserSetting/Detail',
    StripeOrderReceipts: '/Settings/UserSetting/OrderReceipts'
  },
  MyCandidateAlerts: {
    List: '/WorkPlace/MyCandidateAlert/List',
  },
  MyStarter: {
    List: '/WorkPlace/MyStarter/List',
    StarterForm: 'WorkPlace/StarterForm',
    CheckList: 'WorkPlace/CheckList',
    CandidateList: '/JobsAndTalents/CandidateList/List'
  },
  MyTextMessage: {
    List: '/WorkPlace/MyTextMessage/List',
  },
  NewApplication: {
    List: '/WorkPlace/NewApplication/List',
    Email: '/WorkPlace/Email',
  },
  JobAuthorisations: {
    List: '/WorkPlace/MyAuthorisations/List',
  },
  JobandTalent: {
    ViewCandidate: "JobsAndTalents/ViewCandidateDetail/ViewCandidate",
    //CandidateDetail: "/JobsAndTalents/Candidate/Detail/CandidateDetail",
    PreAssessmentFormPreview: "/JobsAndTalents/Candidate/Detail/PreAssessmentFormPreview",
    CompareShortlisting: "/JobsAndTalents/Candidate/Detail/CompareShortlisting",
    ShortlistingPanel: "/JobsAndTalents/Candidate/Detail/ShortlistingPanel",
    InviteToInterview: "JobsAndTalents/Candidate/Shared/InviteToVideoInterview",
    StartDBSCheck: "JobsAndTalents/Candidate/Shared/StartDBSCheck",
    StartGbgKypCheck: "JobsAndTalents/Candidate/Shared/StartGbgKypCheck",
    StartIdentityCheck: "JobsAndTalents/Candidate/StartIdentityCheck",
    Test: "JobsAndTalents/Candidate/Shared/Test",
    List: 'JobsAndTalents/Jobs/List',
    CandidateList: '/JobsAndTalents/CandidateList/List',
    BankDetails: 'JobsAndTalents/Candidate/Shared/Bank/BankDetail',
    StarterForm2: 'JobsAndTalents/Candidate/Shared/StarterForm2',
    SentEmail: 'JobsAndTalents/Jobs/Talents/Email',
    UserDetailForSona: 'JobsAndTalents/Sona/Index',
    EmploymentChecks: {
      TrustId: {
        StartEmploymentChecks: "JobsAndTalents/EmploymentChecks/Index"
      }
    }
  },

  FdmAllocation: {
    AllocatedCandidates: 'JobsAndTalents/Allocation/AllocatedCandidates',
    UnAllocatedCandidates: 'JobsAndTalents/Allocation/UnAllocatedCandidates',
    NewCandidates: 'JobsAndTalents/Allocation/NewCandidates',
    ReminderCandidates: 'JobsAndTalents/Allocation/ReminderCandidates',
    CandidatesNotes: 'JobsAndTalents/Allocation/CanditateNotes',
    ReasinAssignToRecruiter: 'JobsAndTalents/Allocation/ReasinAssignToRecruiter',
    DeferCandidate: 'JobsAndTalents/Allocation/DeferCandidate',
    UnallocateCandidate: 'JobsAndTalents/Allocation/UnallocateCandidate',
    OnOffCandidateAllocation: 'JobsAndTalents/Allocation/OnOffCandidateAllocation',
    Register: 'JobsAndTalents/Allocation/Register',
    ManualAllication: 'JobsAndTalents/Allocation/ManuallAllocation'
  },

  CandidateAhortListing: {
    List: '/WorkPlace/CandidateShortListing',
  },

  UsersUpload: {
    List: '/WorkPlace/UsersUpload'
  },
  LeaversUpload: {
    List: '/WorkPlace/LeaversUpload'
  },
  Reports: {
    DashBoard: 'ReportBuilder/MyReports',
    MyReports: 'Reports/MyReports',
    ListOfJobs: 'Reports/HtmlReports/ListJobs/View',
    HRBusinessPartner: 'Reports/HtmlReports/HRBusinessPartnerComparison/View',
    ListInterViews: 'Reports/HtmlReports/ListInterViews/View',
    ListJobReport: 'Reports/HtmlReports/ListJobs/Report',
    HRBusinessPartnerReport: 'Reports/HtmlReports/HRBusinessPartnerComparison/Report',
    ListInterViewsReport: 'Reports/HtmlReports/ListInterViews/Report',
    ListAgencyAnalysisReport: 'Reports/HtmlReports/AgencyAnalysis/Report',
    ListInitialShiftReport: 'Reports/HtmlReports/InitialSift/Report',
    ListVacancyReport: 'Reports/HtmlReports/Vacancy/Report',
    SourceTrakingReport: 'Reports/HtmlReports/SourceTraking/Report',
    chartreport: 'Reports/htmlReport/chartReport',
    timeToRecruitReport: 'Reports/ChartReports/TimeToRecruit/Report',
    timeToRecruit: 'Reports/ChartReports/TimeToRecruit/View',
    equalOpps: 'Reports/ChartReports/EqualOpps/View',
    SourceTraking: 'Reports/HtmlReports/SourceTraking/View',
    AgencyAnalysis: 'Reports/HtmlReports/AgencyAnalysis/View',
    CandidateStatus: 'Reports/ChartReports/CandidateStatus/View',
    ApplicationPerWeek: 'Reports/ChartReports/AppsPerWeek/View',
    ApplicationWorkflow: 'Reports/ChartReports/WorkflowSummary/View',
    VacancyReport: 'Reports/HtmlReports/Vacancy/View',
    InitialSift: 'Reports/HtmlReports/InitialSift/View',
    RCGroupBy: 'Reports/HtmlReports/RCGroupByRecruiter/View',
    AdvertCostAnalysis: 'Reports/ChartReports/AdvertCostAnalysis/View',
    EqualityCommission: 'Reports/ChartReports/EqualityCommission/View',


    AdvertCostAnalysisReport: 'Reports/ChartReports/AdvertCostAnalysis/Report',
    EqualityCommissionReport: 'Reports/ChartReports/EqualityCommission/Report',

    ApplicationPerWeekReport: 'Reports/ChartReports/AppsPerWeek/Report',
    ApplicationWorkflowReport: 'Reports/ChartReports/WorkflowSummary/Report',
    CandidateStatusReport: 'Reports/ChartReports/CandidateStatus/Report',
    EqualOppsReport: 'Reports/ChartReports/EqualOpps/Report',
    EqualOppsGam: 'Reports/ChartReports/EqualOpps/GamReport',
    RegistrationView: 'Reports/ChartReports/RegistrationMethod/View',
    RegistrationReport: 'Reports/ChartReports/RegistrationMethod/Report',
    BottleNeckReport: 'Reports/HtmlReports/BottleNeck/View',
    BottleNeck: 'Reports/HtmlReports/BottleNeck/Report',
    GetClientDivision: 'Reports/HtmlReports/Reports/BottleNeck',
    RComparisonJobsView: 'Reports/HtmlReports/RComparisonJobsReport/View',
    RComparisonJobsReport: 'Reports/HtmlReports/RComparisonJobsReport/Report',
    RCGroupByReport: 'Reports/HtmlReports/RCGroupByRecruiter/Report',
    CCMSExportRevised: 'Reports/HtmlReports/CCMSExportRevised/View',
    CCMSExportRevisedReport: 'Reports/HtmlReports/CCMSExportRevised/Report',
    ListCandidateByJobView: 'Reports/HtmlReports/ListCandidateByJob/View',
    ListCandidateByJobReport: 'Reports/HtmlReports/ListCandidateByJob/Report',
    CandidateReferenceView: 'Reports/HtmlReports/CandidateReference/View',
    CandidateReferenceReport: 'Reports/HtmlReports/CandidateReference/Report',
    DelAppWithdrawReasonsReport: 'Reports/ChartReports/DeleteAppWithdrawReasons/View',
    DelAppWithdrawReasonsReportDetail: 'Reports/ChartReports/DeleteAppWithdrawReasons/Report',
    ListHftReportView: 'Reports/HtmlReports/HftReport/View',
    ListHftReportReport: 'Reports/HtmlReports/HftReport/Report',
    // ob
    OnboardingReportView: 'Reports/HtmlReports/OnboardingReport/View',
    OnboardingReport: 'Reports/HtmlReports/OnboardingReport/Report',

    ReferenceReportView: 'Reports/HtmlReports/ReferenceReport/View',
    ReferenceReport: 'Reports/HtmlReports/ReferenceReport/Report',

    ComplianeReportView: 'Reports/HtmlReports/ComplianceReport/View',
    ComplianceReport: 'Reports/HtmlReports/ComplianceReport/Report',
    TimedAssessmentReport: 'Reports/ChartReports/TimedAssessment/View',
    TimedAssessmentReportDetail: 'Reports/ChartReports/TimedAssessment/Report',
    TimedAssessmentByGroupReport: 'Reports/ChartReports/TimedAssessmentByGroup/View',
    TimedAssessmentByGroupReportDetail: 'Reports/ChartReports/TimedAssessmentByGroup/Report',
  },
  MyRefrence: {
    List: '/WorkPlace/MyReference/List',
  },
  MyOfferAuthorization: {
    List: '/WorkPlace/MyOfferAuthorization/List',
  },
  SystemUsers: {
    Create: '/Settings/UserSetting/Create',
    List: '/Settings/UserSetting/List',
    UserLogs: '/NewTab/Settings/UserSetting/UserLogs',
  },
  AlertsSetup: {
    List: '/Settings/AlertsSetup/List',
    Create: '/Settings/AlertsSetup/Create'
  },

  MyCandidateAlert: {
    List: '/WorkPlace/MyCandidateAlert/List',
    Create: '/WorkPlace/MyCandidateAlert/Create'
  },

  AddJob: {
    JobDetailChoice: "/JobsAndTalents/AddJob/JobDetailChoice",
    JobDetail: "/JobsAndTalents/AddJob/JobDetails",
    PostJob: "/JobsAndTalents/AddJob/PostJobs",
    JobAdverts: "/JobsAndTalents/AddJob/JobAdverts",
    SmartMatch: "/JobsAndTalents/AddJob/SmartMatch",
    JobAccess: "/JobsAndTalents/AddJob/JobAccess",
    ApprovalForm: "/JobsAndTalents/AddJob/ApprovalForm",
    JobAssessment: "/JobsAndTalents/AddJob/JobAssessment",
    JobAlert: "/JobsAndTalents/AddJob/JobAlert",
    JobNote: "/JobsAndTalents/AddJob/JobNote",
    JtGoPostJob: "/JobsAndTalents/AddJob/PostJobs/PostTheJob",
    PostJobCampaign: "/JobsAndTalents/AddJob/PostJobs/Campaigns",
    JobBoardCheckout: "/JobsAndTalents/AddJob/PostJobs/MarketPlace/Checkout",
    JobBoardMarketPlace: "/JobsAndTalents/AddJob/PostJobs/MarketPlace/Products",
    PostTheJob: "/JobsAndTalents/AddJob/PostJobs/PostTheJob",
    EnhancedMyAuthorisation: "/WorkPlace/EnhancedAuthorisations/List",
    MyAuthorisation: "WorkPlace/MyAuthorisations/List"
  },
  Home: {
    Home: "Home",
    Home1: "/Home",
    ForcePasswordChange: "ForcePasswordChange",
    Interviewbooked: "InterviewsBooked/List"
  },
  HelpAndSupport: {
    ContactForm: '/HelpAndSupport/ContactForm',
    ContactSelect: '/HelpAndSupport/ContactSelect'
  },
  ParseUpload: {
    List: '/WorkPlace/ParseUpload',
    RecentlyUploadedList: 'WorkPlace/RecentlyUploaded/List',
    RecentCandidateDetail: '/WorkPlace/RecentlyUploaded/RecentCandidateDetail',
    CandidateQualifications: '/WorkPlace/RecentlyUploaded/RecentCandidateQualifications',
    CandidateTrainingCourse: '/WorkPlace/RecentlyUploaded/RecentCandidateTrainingCourse',
    CandidateReferences: '/WorkPlace/RecentlyUploaded/RecentCandidateReferences',
    CandidateEmployers: '/WorkPlace/RecentlyUploaded/RecentCandidateEmployers',
    CandidateEqualOpps: '/WorkPlace/RecentlyUploaded/RecentCandidateEqualOpps'
  },



  JobTemplates: {
    List: '/Settings/GeneralSettings/JobTemplates/List',
    Create: '/Settings/GeneralSettings/JobTemplates/Create'
  },

  AccountCode: {
    List: '/Settings/GeneralSettings/eEss/nhsAccountsList',
    Create: '/Settings/GeneralSettings/eEss/nhsAccountsCreate'
  },
  NHSBanks: {
    List: "/Settings/GeneralSettings/eEss/BankList",
    Create: "/Settings/GeneralSettings/eEss/BankCreate"
  },
  NHSJKLBand: {
    List: "/Settings/GeneralSettings/eEss/JKLBand/List",
    Create: "/Settings/GeneralSettings/eEss/JKLBand/Create"
  },
  NHSAvailabilitySupplement: {
    List: "/Settings/GeneralSettings/eEss/AvailabilitySupplement/List",
    Create: "/Settings/GeneralSettings/eEss/AvailabilitySupplement/Create"
  },
  StaffGroup: {
    List: '/Settings/GeneralSettings/eEss/nhsStaffGroupsList',
    Create: '/Settings/GeneralSettings/eEss/nhsStaffGroupsCreate'
  },
  Specialty: {
    List: '/Settings/GeneralSettings/BulkRecruitmentSpecialisms/List',
    Create: '/Settings/GeneralSettings/BulkRecruitmentSpecialisms/Create'
  },
  Specialisms: {
    List: '/Settings/GeneralSettings/AgencySpecialisms/List',
    Create: '/Settings/GeneralSettings/AgencySpecialisms/Create'
  },
  Logos: {
    List: "/Settings/GeneralSettings/Logos/List",
    GenratedFrom: "",
    ClientName: "",
    DbName: "",
  },
  IndividualAccounts: {
    List: '/Settings/GeneralSettings/IndividualAccount/List',
    Create: '/Settings/GeneralSettings/AgencySpecialisms/Create'
  },
  MasterAccount: {
    List: "/Settings/GeneralSettings/MasterAccount/List",
    Create: "/Settings/GeneralSettings/MasterAccount/Create"
  },
  CostCode: {
    List: '/Settings/GeneralSettings/eEss/nhsCostList',
    Create: '/Settings/GeneralSettings/eEss/nhsCostCreate'
  },
  BoardPosition: {
    List: '/Settings/GeneralSettings/eEss/nhsBoardPositionList',
    Create: '/Settings/GeneralSettings/eEss/nhsBoardPositionCreate'
  },
  ComplianceSetting: {
    Redirect: '/Settings/OnBoarding/',
    Create: '/Settings/ComplianceSettings/ComplianceSettings/Create'
  },
  LibraryTypesCompliance: {
    List: '/Settings/ComplianceSettings/LibraryTypes/List',
    Create: '/Settings/ComplianceSettings/LibraryTypes/Create'
  },
  DocumentLibrariesCompliance: {
    List: '/Settings/ComplianceSettings/DocumentLibraries/List',
    Create: '/Settings/ComplianceSettings/DocumentLibraries/Create',

  },
  ComplianceTeams: {
    List: '/Settings/ComplianceSettings/Teams/List',
    Create: '/Settings/ComplianceSettings/Teams/Create'
  },

  OnBoardingStatuses: {
    List: '/Settings/OnBoarding/Statuses/List',
    Create: '/Settings/OnBoarding/Statuses/Create',
  },

  ComplianceTemplates: {
    List: '/Settings/ComplianceSettings/Templates/List',
    Create: '/Settings/ComplianceSettings/Templates/Create'
  },

  OnboardingHub: {
    Overview: '/Settings/OnBoarding/OnboardingHub/Overview',
    ManagerGraphs: '/Settings/OnBoarding/OnboardingHub/Manager',
    Onboarding: '/Settings/OnBoarding/OnboardingHub/Onboarding',
    References: '/Settings/OnBoarding/OnboardingHub/References',
    Compliance: '/Settings/OnBoarding/OnboardingHub/Compliance',
    EmploymentCheck: '/Settings/OnBoarding/OnboardingHub/EmploymentChecks',
  },

  ComplianceDesignSetting: {
    Redirect: 'Settings/OnBoarding/',
    Create: 'Settings/ComplianceSettings/ComplianceDesignSettings/Create'
  },

  DelAndAppWithdrawnReasons: {
    List: 'Settings/GeneralSettings/DelAndAppWithdrawReasons/List',
    Create: 'Settings/GeneralSettings/DelAndAppWithdrawReasons/Create'
  },
  WithdrawReasons: {
    List: 'Settings/Redeployment/WithdrawReasons/List',
    Create: 'Settings/Redeployment/WithdrawReasons/Create'
  },

  GbgKypShortCodes: {
    List: 'Settings/GeneralSettings/GbgKypShortCodes/List',
    Create: 'Settings/GeneralSettings/GbgKypShortCodes/Create'
  },

  JobDescription: {
    List: '/Settings/GeneralSettings/eEss/nhsJobDescriptionsList',
    Create: '/Settings/GeneralSettings/eEss/nhsJobDescriptionsCreate'
  },
  JobStatusAutomation: {
    Detail: "/Settings/GeneralSettings/job-status-automation",
  },

  Positions: {
    List: "/Settings/GeneralSettings/Positions/List",
    Create: "/Settings/GeneralSettings/Positions/Create"
  },
  WorkPattern: {
    List: "/Settings/GeneralSettings/WorkPattern/List",
    Create: "/Settings/GeneralSettings/WorkPattern/Create"
  },
  ColleagueCategory: {
    List: "/Settings/GeneralSettings/ColleagueCategory/List",
    Create: "/Settings/GeneralSettings/ColleagueCategory/Create"
  },

  MarketplaceCampaigns: {
    List: "/Settings/GeneralSettings/MarketplaceCampaigns/List",
    Create: "/Settings/GeneralSettings/MarketplaceCampaigns/Create",
    PostJobCampaignDetail: "/JobsAndTalents/AddJob/PostJobs/Campaigns/Detail",
    ViewReceipt: "/Settings/UserSetting/StripeOrderReceipts",
    ViewReceipt1: "Settings/UserSetting/StripeOrderReceipts"
  },

  ESR: {
    VancancyList: "/integration-hub/create-vacancy",
    ApplicantList: "/integration-hub/create-applicant",
    EmploymentList: "/integration-hub/employment-check",
  },

  PostReference: {
    List: "/Settings/GeneralSettings/PostReference/List",
    Create: "/Settings/GeneralSettings/PostReference/Create"
  },

  OnBoardingDataMigration: {
    List: "/Settings/GeneralSettings/OnBoardingDataMigration/List"
  },

  JtElements: {
    Create: "/Settings/GeneralSettings/JtElements/Create"
  },
  TalentPoolTemplate: {
    List: "/Settings/TalentPoolTemplate/List",
    Create: "/Settings/TalentPoolTemplate/Create",
    View: "/Settings/TalentPoolTemplate/View",
    TalentNetwork: "JobsAndTalents/crm-talent-pool/talent-network-list",
    TalentPoolCandidateList: "JobsAndTalents/crm-talent-pool/talent-pool-candidate-list",
    TalentPool: "JobsAndTalents/crm-talent-pool/talent-pool-list",
    TalentPoolAlert: "JobsAndTalents/crm-talent-pool/talent-pool-alert-list",
    TalentList: '/JobsAndTalents/Capture/TalentList',
    TalentProfile: '/JobsAndTalents/talent-profile/talent-pool-profile',
    RedeploymentCases: "JobsAndTalents/redeployment/cases",
    RedeploymentPreviousCases: "JobsAndTalents/redeployment/previous-cases"
  },
  RedeployeeSettings: {
    Index: "/Settings/Redeployment"
  },
  RedeploymentStatuses: {
    List: '/Settings/Redeployment/Statuses/List',
    Create: '/Settings/Redeployment/Statuses/Create'
  },
  RedeploymentForms: {
    List: '/Settings/Redeployment/RedeploymentForms/List'
  },
  RedeploymentFormDeclaration: {
    List: '/Settings/Redeployment/RedeploymentDeclaration/Index'
  },
  ReportBuilder: {
    Index: "/ReportBuilder/Index",
    ReportPreview: "/ReportBuilder/Preview",
    publicreportlibrary: "/ReportBuilder/public-report-library",
    MyReport: "/ReportBuilder/MyReports",
  },

  AccessDenied: {
    NoAccess: "NoAccess"
  },
  TrustIdBranch: {
    List: '/Settings/GeneralSettings/EmploymentChecks/TrustId/Branch/List',
    Create: "/Settings/GeneralSettings/EmploymentChecks/TrustId/Branch/Create"
  },

  HomePage: {
    EnhancedNotification: "/Notifications",
    },
    DashBoard: {
        List: "/Dashboard/dasboardTemplates/List",
        Create: "/Dashboard/DashboardBuilder",
        BookedInterviewList: "/Dashboard/widgets/InterviewBooked/List"

    },
     AIOrganisationalContext: {
       
         Create: '/Settings/AIOrganisationalContext/Create'
    },
}
